import { ReactComponent as Flag_of_Venezuela } from "../views/Dashboard/assets/Flag_of_Venezuela.svg";
import { ReactComponent as Flag_of_Argentina } from "../views/Dashboard/assets/Flag_of_Argentina.svg";
import { ReactComponent as Flag_of_UnitedStates } from "../views/Dashboard/assets/Flag_of_UnitedStates.svg";
import { ReactComponent as Flag_of_Spain } from "../views/Dashboard/assets/Flag_of_Spain.svg";
import { ReactComponent as Flag_of_Bolivia } from "../views/Dashboard/assets/Flag_of_Bolivia.svg";
import { ReactComponent as Flag_of_Brasil } from "../views/Dashboard/assets/Flag_of_Brasil.svg";
import { ReactComponent as Flag_of_Chile } from "../views/Dashboard/assets/Flag_of_Chile.svg";
import { ReactComponent as Flag_of_Ecuador } from "../views/Dashboard/assets/Flag_of_Ecuador.svg";
import { ReactComponent as Flag_of_Guyana } from "../views/Dashboard/assets/Flag_of_Guyana.svg";
import { ReactComponent as Flag_of_Peru } from "../views/Dashboard/assets/Flag_of_Peru.svg";
import { ReactComponent as Flag_of_Suriname } from "../views/Dashboard/assets/Flag_of_Suriname.svg";
import { ReactComponent as Flag_of_Uruguay } from "../views/Dashboard/assets/Flag_of_Uruguay.svg";
import { ReactComponent as Flag_of_Portugal } from "../views/Dashboard/assets/Flag_of_Portugal.svg";
import { ReactComponent as Flag_of_Italy } from "../views/Dashboard/assets/Flag_of_Italy.svg";
import { ReactComponent as Flag_of_French } from "../views/Dashboard/assets/Flag_of_French.svg";
import { ReactComponent as Flag_of_German } from "../views/Dashboard/assets/Flag_of_German.svg";
import { ReactComponent as Flag_of_Japan } from "../views/Dashboard/assets/Flag_of_Japan.svg";
import { ReactComponent as Flag_of_China } from "../views/Dashboard/assets/Flag_of_China.svg";

export const countryFlags = [
  {
    value: "+34",
    label: (
      <>
        <Flag_of_Spain /> España
      </>
    ),
  },
  {
    value: "+58",
    label: (
      <>
        <Flag_of_Venezuela /> Venezuela
      </>
    ),
  },
  {
    value: "+54",
    label: (
      <>
        <Flag_of_Argentina /> Argentina
      </>
    ),
  },
  {
    value: "+1",
    label: (
      <>
        <Flag_of_UnitedStates /> EE.UU.
      </>
    ),
  },
  {
    value: "+591",
    label: (
      <>
        <Flag_of_Bolivia /> Bolivia
      </>
    ),
  },
  {
    value: "+55",
    label: (
      <>
        <Flag_of_Brasil /> Brasil
      </>
    ),
  },
  {
    value: "+56",
    label: (
      <>
        <Flag_of_Chile /> Chile
      </>
    ),
  },
  {
    value: "+593",
    label: (
      <>
        <Flag_of_Ecuador /> Ecuador
      </>
    ),
  },
  {
    value: "+592",
    label: (
      <>
        <Flag_of_Guyana /> Guyana
      </>
    ),
  },
  {
    value: "+51",
    label: (
      <>
        <Flag_of_Peru /> Perú
      </>
    ),
  },
  {
    value: "+597",
    label: (
      <>
        <Flag_of_Suriname /> Surinam
      </>
    ),
  },
  {
    value: "+598",
    label: (
      <>
        <Flag_of_Uruguay /> Uruguay
      </>
    ),
  },
];

export const languageFlags = [
  {
    code: "es",
    text:"Español",
    label:"Español",
    flag:<Flag_of_Spain/>
  },
  {
    code: "en",
    text:"English",
    label: "English",
    flag:<Flag_of_UnitedStates/>
  },
  {
    code: "pt",
    text:"Português",
    label: "Português",
    flag:<Flag_of_Portugal/>
  },
  {
    code: "it",
    text:"Italiano",
    label: "Italiano",
    flag:<Flag_of_Italy/>
  },

  {
    code: "fr",
    text:"Français",
    label: "Français",
    flag:<Flag_of_French/>
  },
 
  {
    code: "de",
    text:"Deutsch",
    label: "Deutsch",
    flag:<Flag_of_German/>
  },
 
  {
    code: "jpn",
    text:"日本語",
    label: "日本語",
    flag:<Flag_of_Japan/>
  },
 
  {
    code: "cn",
    text:"普通话",
    label: "普通话",
    flag:<Flag_of_China/>
  },
];
